import { useEffect } from 'react';

import { CuredApiPaths } from 'models/enums';
import Card from 'pages/InsightsPage/dashboards/Card';
import { FiltersForApiState } from 'pages/InsightsPage/dashboards/filtering/types';
import useFilteredData from 'pages/InsightsPage/dashboards/filtering/useFilteredData';
import CustomTooltip from 'pages/InsightsPage/visualizations/CustomTooltip';
import LineGraph from 'pages/InsightsPage/visualizations/LineGraph';

type Props = {
    filtersForApi: FiltersForApiState;
};

const NewOptOutsOverTimeCard = ({ filtersForApi }: Props) => {
    const { getData, isError, isLoading, data } = useFilteredData({
        key: 'sms-dashboard/unsubscribes',
        path: CuredApiPaths.REPORT_SMS_UNSUBSCRIBES,
    });

    useEffect(() => {
        getData(filtersForApi);
    }, [filtersForApi, getData]);

    const renderCustomTooltip = (point: any) => (
        <CustomTooltip
            color={point.serieColor}
            label={`unsubscribe date - ${point.data.xFormatted}`}
            value={`opt-out count - ${point.data.yFormatted}`}
        />
    );

    return (
        <Card isError={isError} isLoading={isLoading} label="New Opt-Outs over Time">
            <LineGraph data={[data]} leftLegendLabel="total unsubscribes" renderCustomTooltip={renderCustomTooltip} />
        </Card>
    );
};

export default NewOptOutsOverTimeCard;
